import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatHours'
})
@Injectable({
  providedIn: 'root'
})
export class FormatHoursPipe implements PipeTransform {
  public transform(date: string | Date): string {
    if (date instanceof Date) {
      const hours = Number(date.getHours()) !== 0 ? Number(date.getHours()) + 'h' : '';
      const mins = Number(date.getMinutes()) !== 0 ? Number(date.getMinutes()) + 'min' : '';
      return `${hours} ${mins}`;
    }
    const parsedDate = date.split(':');
    const hours = Number(parsedDate[0]) !== 0 ? Number(parsedDate[0]) + 'h' : '';
    const mins = Number(parsedDate[1]) !== 0 ? Number(parsedDate[1]) + 'min' : '';
    return `${hours} ${mins}`;
  }
}
